//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get';
import VLazyImage from 'v-lazy-image';
import {
  DEAL_PLACEHOLDER_IMG,
  SUMO_DAY_SLUG,
  BLACK_FRIDAY_SLUG,
  BLACK_FRIDAY_LAST_CALL_SLUG,
  SUMO_DAY_PARTICIPATION_SLUG,
  BLACK_FRIDAY_PARTICIPATION_SLUG,
  BLACK_FRIDAY_LAST_CALL_PARTICIPATION_SLUG,
  LAST_CALL_SLUG,
  LAST_CALL_PARTICIPATION_SLUG,
} from '@/constants/global';
import SumoDayBadge from '~/static/sumoday-badge.svg?inline';
import BlackFridayBadge from '~/static/campaigns/black-friday-badge.svg?inline';
import { isWishlistCollectionSlug } from '~/util/global';
import DealBanner from '../utilities/DealBanner.vue';
import DealRating from '../utilities/DealRating.vue';
import WishlistsButton from '../wishlists/Button.vue';

export default {
  components: {
    DealBanner,
    DealRating,
    VLazyImage,
    SumoDayBadge,
    BlackFridayBadge,
    WishlistsButton,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    isCarousel: {
      type: Boolean,
    },
  },
  computed: {
    lazyPlaceholderImage() {
      return DEAL_PLACEHOLDER_IMG;
    },
    hasBanner() {
      // Taken from DealBanner.vue
      return (
        this.deal.browse_deal_status === 'expired'
        || (this.deal.shows_codes_remaining && this.deal.codes_remaining > 0)
        || (
          this.deal.browse_deal_status === 'current'
          && this.deal.dates
          && this.deal.dates.end_date
          && this.deal.has_started
          && this.deal.active_timer
        )
        || this.isComingSoon
      );
    },
    campaigns() {
      return this.$store.getters.campaigns;
    },
    isSumoDay() {
      return this.isParticipatingAndActive(SUMO_DAY_SLUG, SUMO_DAY_PARTICIPATION_SLUG);
    },
    isBlackFriday() {
      return this.isParticipatingAndActive(BLACK_FRIDAY_SLUG, BLACK_FRIDAY_PARTICIPATION_SLUG);
    },
    isBlackFridayLastCall() {
      return this.deal.buy_button?.is_last_call === true
          && this.isParticipatingAndActive(
            BLACK_FRIDAY_LAST_CALL_SLUG,
            BLACK_FRIDAY_LAST_CALL_PARTICIPATION_SLUG,
          );
    },
    isComingSoon() {
      return this.deal.buy_button?.is_coming_soon === true;
    },
    isLastCall() {
      // jl: the isParticipatingAndActive check is needed until separate handling is created for
      // extended access, plus exclusives, and plus freebies. the check can and should be removed
      // once this functionality has been built and existing deals have been transferred over
      return this.deal.buy_button?.is_last_call === true
          && this.isParticipatingAndActive(LAST_CALL_SLUG, LAST_CALL_PARTICIPATION_SLUG);
    },
    isLimitedTimeSale() {
      return this.isLastCall || this.isBlackFridayLastCall;
    },
    isWishlistCollection() {
      return isWishlistCollectionSlug(this.$route?.params.pathMatch);
    },
    wishlistData() {
      return this.$store.getters['wishlists/wishlist'];
    },

  },
  methods: {
    onClickTile(isNewWindow = false) {
      if (!this.isCarousel) {
        if (isNewWindow) {
          window.open(this.deal.get_absolute_url);
        } else {
          this.$router.push(this.deal.get_absolute_url);
        }
      }
    },
    getPlanType(deal) {
      let textStr = '';
      if (deal.unique_plan_types) {
        for (let i = 0; i < deal.unique_plan_types.length; i += 1) {
          const typeArr = deal.unique_plan_types[i];
          if (typeArr[0] === 'One Time Purchase') {
            textStr += 'Lifetime deal';
          } else if (typeArr[0] === 'Limited License') {
            textStr += `${typeArr[2]} ${typeArr[1]} DEAL`;
          } else {
            textStr += typeArr[0];
          }
          if (i < deal.unique_plan_types.length - 1) {
            textStr += ' & ';
          }
        }
      }
      return textStr;
    },
    generateCardDescription(deal) {
      return get(deal, 'card_description');
    },
    isOriginals(deal) {
      return (get(deal, 'internal_tags', []) || []).includes('originals');
    },
    isParticipatingAndActive(campaignSlug, participationSlug) {
      const isCampaignActive = this.campaigns.includes(campaignSlug);
      return isCampaignActive && this.deal.participation?.includes(participationSlug);
    },
  },
};
